import Message from "@amzn/meridian/message";
import { PropsWithChildren } from "react";
import chatIcon from "src/images/safer_chat_icon.png";

export interface BotMessageProps extends PropsWithChildren {
  datetime?: string;
  maxWidth?: string;
  className?: string;
  botName?: string;
}
const BotMessage = ({
  datetime,
  maxWidth = "900px",
  className = "user-bot-response",
  botName = "Safer",
  children,
}: BotMessageProps) => {
  return (
    <div className={`${className} bot-message-top-aligned`}>
      <Message
        name={botName}
        datetime={datetime}
        avatarImageSource={chatIcon}
        type="outgoing"
        maxWidth={maxWidth}
      >
        {children}
      </Message>
    </div>
  );
};

export default BotMessage;
